{
  "income-source-nickname-input-label": "Nickname",
  "income-source-amount-input-label": "Income Amount",
  "income-source-income-type-dropdown-label": "Income Type",
  "income-source-notes-textarea-label": "Notes",

  "investment-nickname-input-label": "Nickname",
  "investment-estimated-value-input-label": "Estimated Value",
  "investment-recurring-contribution-amount-input-label": "Amount",
  "investment-recurring-contribution-percentage-input-label": "Employee Contribution %",
  "investment-income-source-dropdown-label": "Income Source",
  "investment-income-source-dropdown-none-option-label": "None",
  "investment-income-source-required-for-percentage": "Select an income source to set a contribution percentage",
  "investment-percentage-required-for-income": "Enter a contribution percentage for the linked income source",
  "investment-recurring-contribution-derived-from-income-source-tooltip": "Amount and frequency are calculated from the linked income source",
  "investment-mix-dropdown-label": "Investment Mix",

  "cash-account-nickname-input-label": "Nickname",
  "cash-account-estimated-value-input-label": "Estimated Value",
  "cash-account-recurring-contribution-amount-input-label": "Amount",

  "business-name-input-label": "Business Name",
  "business-estimated-value-input-label": "Estimated Value",
  "business-entity-tax-structure-dropdown-label": "Business Tax Structure",
  "business-add-related-documents": "Add Related Documents",
  "business-ownership-allocation-input": "Ownership Percentage",

  "real-estate-property-nickname-input-label": "Nickname",
  "real-estate-property-estimated-value-input-label": "Estimated Value",
  "real-estate-property-state-dropdown-label": "State",
  "real-estate-property-street-address-one-input-label": "Street Address",
  "real-estate-property-street-address-two-input-label": "Apartment, Suite, Unit, etc.",
  "real-estate-property-city-input-label": "City",
  "real-estate-property-zip-code-input-label": "Zip Code",
  "real-estate-property-address-section-header": "Address",

  "loan-type-dropdown-label": "Loan Type",
  "loan-estimated-balance-input-label": "Outstanding Balance",
  "loan-payments-amount-input-label": "Payment Amount",
  "loan-payments-recurring-description": "Recurring Payment",
  "loan-payments-frequency-dropdown-label": "Payment Frequency",
  "loan-nickname-input-label": "Account Nickname",
  "loan-interest-rate-input-label": "Interest Rate",
  "loan-length-of-loan-input-label": "Length of Loan",
  "loan-original-loan-amount-input-label": "Original Loan Amount",
  "loan-start-date-picker-label": "Start Date",
  "loan-interest-rate-type-dropdown-label": "Interest Rate Type",
  "loan-balloon-payment-date-picker-label": "Balloon Payment Date",
  "loan-recurring-contribution-amount-input-label": "Amount",
  "loan-description-of-variable-interest": "Description of Variable Interest",
  "loan-with-balloon-payment-boolean-input-label": "Balloon Payment?",
  "loan-recurring-extra-payments-amount-input-label": "Amount",
  "loan-recurring-extra-payments-frequency-dropdown-label": "Frequency",

  "client-spending-form-spending-input-label": "Estimated Spending",
  "spending-category-estimate-notes-textarea-label": "Notes",

  "person-given-name-input-label": "First Name",
  "person-family-name-input-label": "Last Name",
  "person-email-input-label": "Email",
  "person-phone-input-label": "Phone Number",
  "person-relationship-dropdown-label": "Relationship",
  "person-occupation-input-label": "Occupation",
  "edit-individual": "Edit",
  "add-individual": "Add Individual",

  "user-given-name-input-label": "First Name",
  "user-family-name-input-label": "Last Name",
  "user-email-input-label": "Email",

  "general-owner-dropdown-label": "Owner",
  "general-frequency-dropdown-label": "Frequency",
  "general-required-placeholder": "Required",
  "general-dob-date-picker-label": "Date of Birth",
  "general-frequency-input-frequency-month-abbr": "mo",
  "general-frequency-input-frequency-year-abbr": "yr",
  "general-password-input-label": "Password",
  "general-given-name-input-label": "First Name",
  "general-family-name-input-label": "Last Name",
  "general-email-input-label": "Email",
  "general-phone-input-label": "Phone Number",
  "general-add-related-documents": "Add Related Documents",
  "general-related-documents": "Related Documents",
  "general-owned-by-dropdown-label": "Owned By",
  "general-ownership": "Ownership",
  "general-ownership-allocation-input": "Ownership Percentage",
  "general-recurring-savings-contributions": "Recurring Savings Contributions",
  "general-partial-ownership-discount-helper-text": "This value will be discounted due to partial ownership.",
  "general-add-attachment": "Add Attachment",

  "general-placeholder-required": "Required",

  "taxReturnSummary-filling-status-dropdown-label": "Filling Status",
  "taxReturnSummary-personal-income-input-label": "Estimated Personal Income",
  "taxReturnSummary-federal-taxes-paid-input-label": "Federal Taxes Paid",
  "taxReturnSummary-state-taxes-paid-input-label": "State Taxes Paid",
  "taxReturnSummary-year-dropdown-label": "Tax Year",
  "tax-returns-summary-form-add-related-documents": "Add Tax Documents",
  "tax-return-summary-form-related-documents-title": "Tax Documents",

  "personal-property-item-nickname-input-label": "Item Nickname",
  "personal-property-item-estimated-value-input-label": "Estimated Value",

  "note-receivable-nickname-input-label": "Item Nickname",
  "note-receivable-estimated-value-input-label": "Estimated Value",

  "password-updated-successfully": "Your password was successfully updated.",
  "update-password-btn": "Update Password",
  "update-password-title": "Update Password",
  "password-current": "Current Password",
  "password-new": "New Password",
  "password-new-confirm": "Confirm New Password",

  "err-invalid-email": "Invalid email.",
  "err-invalid-password": "Invalid password.",
  "err-invalid-device-friendly-name": "Invalid authenticator app.",
  "err-additional-auth-challenges": "Unable to complete request, please sign out and sign in, then try again.",
  "err-invalid-totp-code": "Incorrect code. Please double-check your verification code and try again.",
  "err-invalid-credentials": "The Email or Password you entered was incorrect. Please try again.",
  "err-invalid-password-complexity": "Password must be at least 10 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.",
  "err-invalid-password-same-as-current": "New password cannot be the same as current password.",
  "err-password-change-limit-exceeded": "You have exceeded the maximum number of password changes allowed. Please try again later.",
  "err-invalid-password-try-again": "The password you entered doesn't match our records. Please try again.",
  "err-passwords-dont-match": "Passwords don't match. Double check and try again.",

  "firm-member-calendar-scheduling-link-input-label": "Calendar Link"
}
